import React, { useState } from "react";
import {
  faCheck,
  faPlusCircle,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, FieldArray, Formik, useFormikContext } from "formik";
import { Form, Button } from "react-bootstrap";
import SearchableList from "../SearchableList";
import { get, isEmpty } from "lodash";
import { FieldDropSide, FieldInput } from "../Forms";
import {
  ConditionCategory,
  filterCondition,
  removePassthroughFieldTrans,
} from "../../utils";
import RuleFilterSlider from "./RuleFilterSlider";
import { AddToolTip, Link } from "..";
import FieldSetupSlider from "../../containers/Mapper/MapAndTransformOutput/FieldSetupSlider";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import { default as uuid } from "uuid";
import { useContext } from "react";
import { manageMapperStore } from "../../contexts";

const RuleFilter = (props) => {
  const { index, isSubRuleSaved } = props;
  const { flow, profileId, mapType } = useRouterParams();
  const { state, dispatch } = useContext(manageMapperStore);
  const headersJson = get(state, "api.data.headerMapJson");
  const [mappedData, setMappedData] = useState();
  const [showSlide, setShowSlide] = useState(false);
  const [fieldIndex, setFieldIndex] = useState(0);
  const [fieldName, setFieldName] = useState("");
  const [innerFieldIndex, setInnerFieldIndex] = useState(0);
  const [preValue, setPreValue] = useState();
  const [fieldArrayName, setFieldArrayName] = useState(null);
  const [masterSourceDate, setMasterSourceDate] = useState();
  const { values, handleChange, setFieldValue } = useFormikContext();
  useDeepEffect(() => {
    try {
      const parseField = headersJson;
      if (!isEmpty(parseField)) {
        const parsedHeadersJson = JSON.parse(parseField);
        setMasterSourceDate(
          parsedHeadersJson?.map((item) => ({
            id: uuid.v4(),
            order: item.order,
            propertyName: item.propertyName,
            fieldName: item.fieldName,
            type: item.type,
            datum: item.datum,
          }))
        );
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
      // Handle the error as needed
    }
  }, [headersJson]);
  return (
    <div
      style={{
        minHeight: "100%",
        maxHeight: "100%",
        overflowY: "auto",
      }}
    >
      <div className="source-flex-around mt-3">
        <div className="filter-condition-text mr-2">If</div>
        <div>
          <Field
            size={"sm"}
            name={`ruleSet[${index}].filterCondition`}
            onChange={handleChange}
            options={filterCondition}
            placeholder={"All"}
            isRequired
            direction={"bottom"}
            value={values.ruleSet[index].filterCondition}
            popupContent={
              <SearchableList
                isNotTypeAhead
                label="Click here to add"
                name={"filterCondition"}
                selectedValue={values.ruleSet[index].filterCondition}
                onSelect={(e, label) => {
                  setFieldValue(`ruleSet[${index}].ruleOperations`, [
                    {
                      firstFieldRule: null,
                      conditionCategory: "IsNotNullOrEmpty",
                    },
                  ]);
                  setFieldValue(`ruleSet[${index}].filterCondition`, e);
                }}
                options={filterCondition}
              />
            }
            component={FieldDropSide}
          />
        </div>
      </div>
      <div style={{ marginLeft: "60px" }} className="mb-4">
        <ul className="sourceCollectiontree flair-rules-if">
          <FieldArray name={`ruleSet[${index}].ruleOperations`}>
            {({ push: innerPush, remove }) => (
              <>
                {values["ruleSet"][index]["ruleOperations"]?.map(
                  (innerItem, ind) => {
                    var filterParam = ConditionCategory?.filter(
                      (_) => _.value == innerItem.conditionCategory
                    );
                    return (
                      <li className="listSourceCollectiontree d-flex">
                        <div className="source-flex-around">
                          <span className=" d-flex flex-col">
                            <div className="click-to-add-if">
                              {isEmpty(
                                get(
                                  values,
                                  `ruleSet[${index}].ruleOperations[${ind}].firstFieldRule`,
                                  null
                                )
                              ) ? (
                                <>
                                  <Link
                                    onClick={() => {
                                      setShowSlide(true);
                                      setFieldIndex(index);
                                      setInnerFieldIndex(ind);
                                      setFieldName("firstFieldRule");
                                    }}
                                    className="click-to-source mr-1"
                                    style={{ color: "#307bf6" }}
                                  >
                                    Click
                                  </Link>
                                  <p className="click-to-source">
                                    to add field(s)
                                  </p>
                                </>
                              ) : (
                                <span
                                  className="sub-expression"
                                  onClick={() => {
                                    setShowSlide(true);
                                    setFieldIndex(index);
                                    setInnerFieldIndex(ind);
                                    setFieldName("firstFieldRule");
                                    setMappedData(
                                      removePassthroughFieldTrans(
                                        get(
                                          values,
                                          `ruleSet[${index}].ruleOperations[${ind}].firstFieldRule`,
                                          null
                                        )
                                      )
                                    );
                                  }}
                                >
                                  <AddToolTip
                                    name={removePassthroughFieldTrans(
                                      get(
                                        values,
                                        `ruleSet[${index}].ruleOperations[${ind}].firstFieldRule`,
                                        null
                                      )
                                    )}
                                  />
                                </span>
                              )}
                            </div>
                            {isSubRuleSaved &&
                              get(
                                values,
                                `ruleSet[${index}].ruleOperations[${ind}].firstFieldRule`,
                                null
                              ) == null && (
                                <span className="error-message ml-3">
                                  Required
                                </span>
                              )}
                          </span>
                          <div className="condition-width-rule">
                            <Field
                              size={"sm"}
                              name={`ruleSet[${index}].ruleOperations[${ind}].conditionCategory`}
                              isRequired
                              direction={"bottom"}
                              value={get(
                                values,
                                `ruleSet[${index}].ruleOperations[${ind}].conditionCategory`,
                                null
                              )}
                              options={ConditionCategory}
                              popupContent={
                                <SearchableList
                                  label="Click here to add"
                                  isNotTypeAhead
                                  name={`ruleSet[${index}].ruleOperations[${ind}].conditionCategory`}
                                  selectedValue={get(
                                    values,
                                    `ruleSet[${index}].ruleOperations[${ind}].conditionCategory`,
                                    null
                                  )}
                                  onSelect={(value, label) => {
                                    var filterRuleCondition = ConditionCategory.filter(
                                      (_) => _.value == value
                                    );
                                    setFieldValue(
                                      `ruleSet[${index}].ruleOperations[${ind}].secondFieldRule0`,
                                      undefined
                                    );
                                    setFieldValue(
                                      `ruleSet[${index}].ruleOperations[${ind}].secondFieldRule1`,
                                      undefined
                                    );
                                    filterRuleCondition[0].parameters?.map(
                                      (itm, inds) => {
                                        setFieldValue(
                                          `ruleSet[${index}].ruleOperations[${ind}].secondFieldRule${inds}`,
                                          null
                                        );
                                      }
                                    );
                                    setFieldValue(
                                      `ruleSet[${index}].ruleOperations[${ind}].conditionCategory`,
                                      value
                                    );
                                  }}
                                  options={ConditionCategory}
                                />
                              }
                              onChange={handleChange}
                              component={FieldDropSide}
                            />
                          </div>
                          {filterParam[0]?.parameters?.map((item, list) => {
                            return (
                              <span>
                                <div className="click-to-add-if">
                                  {isEmpty(
                                    get(
                                      values,
                                      `ruleSet[${index}].ruleOperations[${ind}].secondFieldRule${list}`,
                                      null
                                    )
                                  ) ? (
                                    <>
                                      <Link
                                        onClick={() => {
                                          setShowSlide(true);
                                          setFieldIndex(index);
                                          setInnerFieldIndex(ind);
                                          setFieldName(
                                            `secondFieldRule${list}`
                                          );
                                        }}
                                        className="click-to-source mr-1"
                                        style={{ color: "#307bf6" }}
                                      >
                                        Click
                                      </Link>
                                      <p className="click-to-source">
                                        to add field(s)
                                      </p>
                                    </>
                                  ) : (
                                    <span
                                      className="sub-expression"
                                      onClick={() => {
                                        setShowSlide(true);
                                        setFieldIndex(index);
                                        setInnerFieldIndex(ind);
                                        setFieldName(`secondFieldRule${list}`);
                                        setMappedData(
                                          removePassthroughFieldTrans(
                                            get(
                                              values,
                                              `ruleSet[${index}].ruleOperations[${ind}].secondFieldRule${list}`,
                                              null
                                            )
                                          )
                                        );
                                      }}
                                    >
                                      <AddToolTip
                                        name={removePassthroughFieldTrans(
                                          get(
                                            values,
                                            `ruleSet[${index}].ruleOperations[${ind}].secondFieldRule${list}`,
                                            null
                                          )
                                        )}
                                      />
                                    </span>
                                  )}
                                </div>
                                {isSubRuleSaved &&
                                  get(
                                    values,
                                    `ruleSet[${index}].ruleOperations[${ind}].secondFieldRule${list}`,
                                    null
                                  ) == null && (
                                    <span className="error-message ml-3">
                                      Required
                                    </span>
                                  )}
                              </span>
                            );
                          })}
                        </div>
                        {get(
                          values,
                          `ruleSet[${index}].filterCondition`,
                          null
                        ) != "Not" && (
                          <div className="pl-4">
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              color="#FF0000"
                              size={"lg"}
                              style={{ cursor: "default" }}
                              onClick={() => remove(ind)}
                            />
                          </div>
                        )}
                      </li>
                    );
                  }
                )}
                {get(values, `ruleSet[${index}].filterCondition`, null) !=
                  "Not" &&
                  get(values, `ruleSet[${index}].ruleOperations`, []).length <
                    5 && (
                    <li className="listSourceCollectiontree plus-icon-rule-filter">
                      <span
                        className="d-flex"
                        onClick={() => {
                          innerPush({
                            firstFieldRule: null,
                            conditionCategory: "IsNotNullOrEmpty",
                          });
                        }}
                      >
                        <FontAwesomeIcon
                          className="ml-3 mt-2 d-flex rule-filter-plus-icon"
                          icon={faPlusCircle}
                          size="2x"
                        />
                        <p className="new-rule-filter-text">New</p>
                      </span>
                    </li>
                  )}
              </>
            )}
          </FieldArray>
        </ul>
        {showSlide && (
          //   <FieldSetupSlider
          //   setShowSlideOut={setShowSlide}
          //   mappedData={mappedData}
          //   setMappedData={setMappedData}
          //   fieldIndex={fieldIndex}
          //   setFieldIndex={setFieldIndex}
          //   index={fieldIndex}
          //   showSlideOut={showSlide}
          //   hasHeader={list[fieldIndex]?.isNewField}
          //   fieldArrayName={fieldArrayName}
          //   masterSourceDate={masterSourceDate}
          //   setFieldArrayName={setFieldArrayName}
          //   profileId={profileId}
          //   dataModel={4}
          //   mapType={mapType}
          //   sourceHeaderName={
          //     !isEmpty(list) && list[fieldIndex]?.fieldName?.substring(1)
          //   }
          // />
          <RuleFilterSlider
            setFieldValue={setFieldValue}
            preValue={preValue}
            setPreValue={setPreValue}
            setShowSlide={setShowSlide}
            mappedData={mappedData}
            fieldName={fieldName}
            setMappedData={setMappedData}
            fieldIndex={fieldIndex}
            innerFieldIndex={innerFieldIndex}
            index={0}
            showSlide={showSlide}
            hasHeader={false}
            fieldArrayName={fieldArrayName}
            masterSourceDate={masterSourceDate}
            setFieldArrayName={setFieldArrayName}
            profileId={profileId}
            dataModel={4}
            mapType={mapType}
            sourceHeaderName={null}
          />
        )}
      </div>
    </div>
  );
};

export default RuleFilter;
